import _ from 'lodash'
import { Feature } from 'ol'
import Collection from 'ol/Collection'
import { GeoJSON, KML } from 'ol/format'
import { Geometry, GeometryCollection } from 'ol/geom'
import Point from 'ol/geom/Point'
import { fromLonLat } from 'ol/proj'
import VectorSource from 'ol/source/Vector'
import React, { useEffect, useState } from 'react'
import { Grid, GridColumn, GridRow, Icon, List, ListItem } from 'semantic-ui-react'
import 'swiper/components/navigation/navigation.min.css'
import 'swiper/components/pagination/pagination.min.css'

import SwiperCore, { Navigation, Pagination } from 'swiper/core'

import 'swiper/swiper.min.css'
import {
  PLACENAME_PUBLIC_APP_PATH,
  PLANNING_SERVICES_EMAIL,
  PLANNING_SERVICES_PHONE,
  PLANNING_SERVICES_PHONE_INTERNATIONAL,
} from '../../../environment'
import { MapUtils } from '../../map/map.utils'
import { PlacenameDataType, PlacenameDataTypeProp } from '../slice'
import './PlacenameTab.css'

// install Swiper modules
SwiperCore.use([Pagination, Navigation])


export default function PlacenameTab1({ placenameData }: PlacenameDataTypeProp) {
  const [kmlData, setKmlData] = useState<string>()
  const [urlBushTel] = useState<string>('http://www.bushtel.nt.gov.au/profile/')

  function createKmlData(kml: string) {
    let blob = new Blob([kml], { type: 'application/vnd.google-earth.kmz' })
    setKmlData(URL.createObjectURL(blob))
  }

  useEffect(
    () => {
      let kml_format
      let vectorSource: VectorSource
      const layerFeatures: Feature<Geometry>[] = []
      const layerFeaturesCollection = new Collection<Feature>()

      if (!_.isEmpty(placenameData) && placenameData) {
        let styleId = 'geometryStyle'
        if (placenameData.altGeometry && placenameData.altGeometry.length > 0 && placenameData.altGeometry[0]) {
          let geometries = getGeometries(placenameData)
          if (placenameData.latitude && placenameData.longitude) {
            const labelPos = new Point(fromLonLat(MapUtils.longLatToCoord(placenameData.longitude, placenameData.latitude)))
            geometries.push(labelPos)
          }

          const layerFeature = new Feature({
            geometry: new GeometryCollection(geometries),
            name: placenameData.searchTerm,
            description: getDescription(),
            styleUrl: styleId,
          })

          layerFeatures.push(layerFeature)
          layerFeaturesCollection.extend(layerFeatures)

          vectorSource = new VectorSource({
            features: layerFeaturesCollection,
          })

          if (vectorSource && vectorSource.getFeatures()) {
            kml_format = new KML()
            let kml = kml_format.writeFeatures(vectorSource.getFeatures(), { featureProjection: 'EPSG:3857' })
            const docu = new DOMParser().parseFromString(kml, 'application/xml')
            const placemark = docu.querySelector('Placemark')
            if (placemark) {
              const parent = placemark!.parentNode
              const documentSection = docu.createElement('Document')
              parent!.replaceChild(documentSection, placemark!)
              if (placenameData.dataType === 'Road') {
                documentSection.appendChild(getPolygonStyle(styleId, '7d0000ff', '5', '7d0000ff'))
              } else {
                documentSection.appendChild(getPolygonStyle(styleId, '64FF78B4', '3', '50FF78B4'))
              }
              documentSection.appendChild(placemark)
            }
            createKmlData(new XMLSerializer().serializeToString(docu))
          }
        } else if (placenameData.latitude && placenameData.longitude) {
          const labelPos = new Point(fromLonLat(MapUtils.longLatToCoord(placenameData.longitude, placenameData.latitude)))
          const layerFeature = new Feature({
            geometry: labelPos,
            name: placenameData.searchTerm,
            description: getDescription(),
            styleUrl: 'root://styleMaps#default+nicon=0x307+hicon=0x317',
          })
          layerFeatures.push(layerFeature)
          vectorSource = new VectorSource({
            features: layerFeatures,
          })
          if (vectorSource && vectorSource.getFeatures()) {
            kml_format = new KML()
            let kml = kml_format.writeFeatures(vectorSource!.getFeatures(), { featureProjection: 'EPSG:3857' })
            createKmlData(kml)
          }

        }

      }
      return () => {

      }

    }, [placenameData],
  )

  function getGeometries(placenameData: PlacenameDataType) {
    let geometries: Geometry[] = []
    placenameData!.altGeometry!.forEach(
      (altGeometry) => {
        let geometry = (new GeoJSON()).readGeometry(altGeometry).transform('EPSG:4326', 'EPSG:3857')
        geometries.push(geometry)
      },
    )
    return geometries
  }

  function getDescription() {
    const placenameRegisterUrl = PLACENAME_PUBLIC_APP_PATH + placenameData.placeId
    const bushUrl = urlBushTel + placenameData.placeId
    return ('Type: ' + placenameData.dataType + '<br/><br/>' +
      'Designation: ' + (placenameData.typeDesignation ? placenameData.typeDesignation : 'UNAVAILABLE') + '<br/><br/>' +
      'History:<br/>' +
      (placenameData.historyOrigin ? placenameData.historyOrigin : 'UNAVAILABLE') + '<br/><br/>' +
      'Alternate Names:<br/>' +
      (placenameData.alternateNames ? placenameData.alternateNames : 'UNAVAILABLE') + '<br/><br/>' +
      'Get more information about this place from:<br/>' +
      '- <a href=' + placenameRegisterUrl + '>NT Placenames Register</a><br/>' +
      (placenameData.dataType === 'Aboriginal Community' && placenameData.typeDesignation !== 'Archived' ? '- <a href=' + bushUrl + '>Bush Telegraph</a><br/><br/>' : '') +
      '<br/><br/>'
    )
  }

  function getPolygonStyle(styleId: string, lColor: string, lWidth: string, pColor: string) {
    const docu = new DOMParser().parseFromString('', 'application/xml')
    const style = docu.createElement('Style')
    style.id = styleId
    const lineStyle = docu.createElement('LineStyle')
    const lineWidth = docu.createElement('width')
    const lineColor = docu.createElement('color')
    lineColor.innerHTML = lColor ? lColor : '64FF78B4'
    lineWidth.innerHTML = lWidth ? lWidth : '5'
    const polyStyle = docu.createElement('PolyStyle')
    const polyColor = docu.createElement('color')
    polyColor.innerHTML = pColor ? pColor : '50FF78B4'

    polyStyle.appendChild(polyColor)
    lineStyle.appendChild(lineWidth)
    lineStyle.appendChild(lineColor)
    style.appendChild(lineStyle)
    style.appendChild(polyStyle)
    return style
  }


  function displayOfficialName() {
    return (
      <React.Fragment>
        <GridRow className="placenameDetailsL1Row">
          <GridColumn width={6} className="placenameDetailsFieldLabel">
            <p>Alias:</p>
          </GridColumn>
          <GridColumn width={10} className="placenameDetailsFieldValue">
            <p>{placenameData.alternateNames ? placenameData.alternateNames : 'UNAVAILABLE'}</p>
          </GridColumn>
        </GridRow>
      </React.Fragment>
    )
  }

  function displayDesignationType() {
    return (
      <React.Fragment>
        <GridRow className="placenameDetailsL1Row">
          <GridColumn width={6} className="placenameDetailsFieldLabel">
            <p>Type of Designation:</p>
          </GridColumn>
          <GridColumn width={10} className="placenameDetailsFieldValue">
            <p>{placenameData.typeDesignation ? placenameData.typeDesignation : 'UNAVAILABLE'}</p>
          </GridColumn>
        </GridRow>
      </React.Fragment>
    )
  }

  function displayPlaceId() {
    return (
      <React.Fragment>
        <GridRow className="placenameDetailsL1Row">
          <GridColumn width={6} className="placenameDetailsFieldLabel">
            <p>Place Id:</p>
          </GridColumn>
          <GridColumn width={10} className="placenameDetailsFieldValue">
            <p>{placenameData.placeId ? placenameData.placeId : 'UNAVAILABLE'}</p>
          </GridColumn>
        </GridRow>
      </React.Fragment>
    )
  }

  function displayPlaceType() {
    return (
      <React.Fragment>
        <GridRow className="placenameDetailsL1Row">
          <GridColumn width={6} className="placenameDetailsFieldLabel">
            <p>Place Type:</p>
          </GridColumn>
          <GridColumn width={10} className="placenameDetailsFieldValue">
            <p>{placenameData.dataType ? placenameData.dataType : 'UNAVAILABLE'}</p>
          </GridColumn>
        </GridRow>
      </React.Fragment>
    )
  }

  function displayPlaceStatus() {
    return (
      <React.Fragment>
        <GridRow className="placenameDetailsL1Row">
          <GridColumn width={6} className="placenameDetailsFieldLabel">
            <p>Status:</p>
          </GridColumn>
          <GridColumn width={10} className="placenameDetailsFieldValue">
            <p>{placenameData.placeStatus ? placenameData.placeStatus : 'UNAVAILABLE'}</p>
          </GridColumn>
        </GridRow>
      </React.Fragment>
    )
  }

  function displayDateRegistered() {
    const serverDate = placenameData.dateRegistered?.split('-')
    const dateRegistered = serverDate ? serverDate[2] + '/' + serverDate[1] + '/' + serverDate[0] : ''
    return (
      <React.Fragment>
        <GridRow className="placenameDetailsL1Row">
          <GridColumn width={6} className="placenameDetailsFieldLabel">
            <p>Date Registered:</p>
          </GridColumn>
          <GridColumn width={10} className="placenameDetailsFieldValue">
            <p>{dateRegistered ? dateRegistered : 'UNAVAILABLE'}</p>
          </GridColumn>
        </GridRow>
      </React.Fragment>
    )
  }

  function displayLocation() {
    const lat = placenameData.latitude
    const lon = placenameData.longitude
    const placeId = placenameData.placeId
    const units = ' Decimal degrees'
    const urlNtAtlas = 'http://www.ntlis.nt.gov.au/imfPublic/imf.jsp?site=nt_atlas&qhlt=true&qsel=true&qbuf=0.01&qlyr=9&qry=PLACE_ID%3D' + placeId
    return (
      <React.Fragment>
        <GridRow className="placenameDetailsL1Row">
          <GridColumn width={6} className="placenameDetailsFieldLabel">
            <p>Location<br/>(Datum GDA94):</p>
          </GridColumn>
          <GridColumn width={10} className="placenameDetailsFieldValue">
            <p>Latitude:&nbsp;{lat ? lat + units : 'UNAVAILABLE'}</p>
            <p>Longitude:&nbsp;{lon ? lon + units : 'UNAVAILABLE'}</p>
          </GridColumn>
        </GridRow>
        <GridRow className="placenameDetailsL1Row row-no-divider">
          <GridColumn width={6} className="placenameDetailsFieldLabel">
            <p> View In: </p>
          </GridColumn>
          <GridColumn width={10} className="placenameDetailsFieldValue">
            <List>
              <ListItem><a href={urlNtAtlas}>NT Atlas</a></ListItem>
              {kmlData && <ListItem><a href={kmlData} download={placeId + '.kml'}>Google Earth</a></ListItem>}
              {placenameData.dataType === 'Aboriginal Community' && placenameData.typeDesignation !== 'Archived' &&
                  <ListItem><a href={urlBushTel + placeId}>BushTel</a></ListItem>
              }
            </List>
          </GridColumn>
        </GridRow>
      </React.Fragment>
    )
  }

  function displayLocality() {
    const locality = placenameData.localities
    return (
      <React.Fragment>
        <GridRow className="placenameDetailsL1Row">
          <GridColumn width={6} className="placenameDetailsFieldLabel">
            <p>Locality:</p>
          </GridColumn>
          <GridColumn width={10} className="placenameDetailsFieldValue">
            <p>{locality ? locality : 'UNAVAILABLE'}</p>
          </GridColumn>
        </GridRow>
      </React.Fragment>
    )
  }

  function displayLGA() {
    const lga = placenameData.localGovernmentAreas
    return (
      <React.Fragment>
        <GridRow className="placenameDetailsL1Row">
          <GridColumn width={6} className="placenameDetailsFieldLabel">
            <p>Local Government Area:</p>
          </GridColumn>
          <GridColumn width={10} className="placenameDetailsFieldValue">
            <p>{lga ? lga : 'UNAVAILABLE'}</p>
          </GridColumn>
        </GridRow>
      </React.Fragment>
    )
  }

  function displayTheme() {
    const themes = placenameData.namingThemes
    return (
      <React.Fragment>
        <GridRow className="placenameDetailsL1Row">
          <GridColumn width={6} className="placenameDetailsFieldLabel">
            <p>Naming Theme:</p>
          </GridColumn>
          <GridColumn width={10} className="placenameDetailsFieldValue">
            <p>{themes && themes !== 'None' ? themes : 'UNAVAILABLE'}</p>
          </GridColumn>
        </GridRow>
      </React.Fragment>
    )
  }

  function displayPlacenameUnavailableError() {
    return (
      <React.Fragment>

        <GridColumn width={16}>
          <div className={'largePlanningError'}>
            <Icon name={'warning circle'} size={'large'}/>
            <p>Unavailable</p>
          </div>
          <p style={{ textAlign: 'center' }}>Planning Details not available online. Please contact Development
            Assessment Services
            on <a href={`mailto: ${PLANNING_SERVICES_EMAIL}`}>{PLANNING_SERVICES_EMAIL}</a> or phone: <a
              href={`tel:${PLANNING_SERVICES_PHONE_INTERNATIONAL}`}>{PLANNING_SERVICES_PHONE}</a></p>
        </GridColumn>

      </React.Fragment>
    )
  }

  function displayInternalError() {
    return (
      <React.Fragment>

        <GridColumn width={16}>
          <div className={'largePlanningError'}
               style={{ textAlign: 'center', fontWeight: 'bolder', color: 'indianred', fontSize: '3em' }}>
            <Icon name={'warning circle'} size={'large'}/>
            <p>Error</p>
          </div>
          <p style={{ textAlign: 'center' }}>Online plannings are currently unavailable. If your query is urgent
            please contact Valuation Services on <a
              href={`mailto: ${PLANNING_SERVICES_EMAIL}`}>{PLANNING_SERVICES_EMAIL}</a> or phone: <a
              href={`tel:${PLANNING_SERVICES_PHONE_INTERNATIONAL}`}>{PLANNING_SERVICES_PHONE}</a></p>
        </GridColumn>

      </React.Fragment>
    )
  }

  function displayFields() {
    if (placenameData.error && placenameData.errorType === 'INTERNAL_ERROR') {
      // internal error
      return (
        <React.Fragment>
          {displayInternalError()}
        </React.Fragment>
      )
    } else if (placenameData.error) {
      return (
        <React.Fragment>
          {displayPlacenameUnavailableError()}
        </React.Fragment>
      )
    } else if (!placenameData.error) {
      return (
        <React.Fragment>
          {displayValidPlacenameFields()}
        </React.Fragment>
      )
    }
  }

  function displayValidPlacenameFields() {
    return (
      <React.Fragment>
        {displayOfficialName()}
        {displayDesignationType()}
        {displayPlaceId()}
        {displayPlaceType()}
        {displayPlaceStatus()}
        {displayDateRegistered()}
        {displayLocation()}
        {displayLocality()}
        {displayLGA()}
        {displayTheme()}
      </React.Fragment>
    )
  }

  return (
    <React.Fragment>
      <Grid className="placenameFieldsGrid" divided="vertically">
        {displayFields()}
      </Grid>
    </React.Fragment>
  )
}

